import React from "react";
import * as S from "./styles";
import sorrisoVideo from "assets/videos/sorriso.mp4";

export const DiaSorriso: React.FC = () => {
  console.log("Entrei ");
  return (
    <>
      <S.Container>
        <S.AreaVideo>
          <S.AtletasVideo src={sorrisoVideo} controls autoPlay loop muted>
            {/* Fallback para navegadores que não suportam a tag <video> */}
            Seu navegador não suporta a tag de vídeo.
          </S.AtletasVideo>
        </S.AreaVideo>
      </S.Container>
    </>
  );
};
